const handler = ( $ ) => {
	const initSearchClear = () => {
		const searchForm = $(
			'.search-page-results .search-form__input .search-input'
		);

		if ( searchForm.length ) {
			const searchInput = searchForm.find( 'input[type="text"]' );
			const searchButton = searchForm.find( 'button[type="submit"]' );

			const updateClearButton = () => {
				searchButton.removeClass( 'clear-button' );
			};

			if ( searchInput.val().trim() !== '' ) {
				searchButton.addClass( 'clear-button' );
			}

			searchInput.on( 'input', updateClearButton );

			searchButton.on( 'click', function ( e ) {
				if ( $( this ).hasClass( 'clear-button' ) ) {
					e.preventDefault();
					searchInput.val( '' );
					searchInput.focus();
					searchButton.removeClass( 'clear-button' );
				}
			} );
		}
	};

	initSearchClear();
};

export default ( ( $ ) => $( handler ) )( jQuery );
